<script>
  export let text = "Pas de Contenu";
</script>

<div class="w-full h-32 my-4 flex flex-col items-center justify-center">
  <h1 class="mb-4 text-red-400 flex items-center">
    {text}
  </h1>
  <ion-icon name="alert-circle" class="text-6xl text-red-400" />
</div>
